import React, { useContext, useState } from 'react'
import WelcomeMessage from '../../components/WelcomeMessage/WelcomeMessage'
import InputField from '../../components/InputField/InputField'
import Button from '../../components/Button/Button'
import { MallContext } from '../../MallContext';
import { useLocation, useNavigate } from 'react-router-dom';
import Services from '../../services/Services';

export default function Register() {
  const { token } = useContext(MallContext);
  const navigate = useNavigate()
  const location = useLocation();
  const { phoneNumber, emailAddress } = location.state || {};

  const [name, setName] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState(emailAddress || "");
  const [identityNo, setIdentityNo] = useState("");

  function generateSixDigitCode() {
    return Math.floor(100000 + Math.random() * 900000);
  }

  const createUser = () => {
    const finalPhone = phoneNumber || "";
    const finalEmail = email || "";

    Services.CreateUser(token, name, lastname, finalEmail, finalPhone, identityNo, generateSixDigitCode())
      .then((res) => {
        if (res.data.status) {
          localStorage.setItem('customerID', res.data.result.customerID)
          localStorage.setItem("name", name)
          localStorage.setItem("lastname", lastname)
          localStorage.setItem("email", finalEmail)
          localStorage.setItem('phoneNumber', finalPhone)

          navigate('/mainpage')
        } else {
          console.log(res.data);
        }
      })
      .catch((err) => console.log(err));
  }

  const isPhoneRegistration = !!phoneNumber;
  const isButtonDisabled = !name || !lastname || (isPhoneRegistration && !identityNo);

  return (
    <div>
      <WelcomeMessage message="Lütfen kayıt olmak için bilgilerinizi giriniz." />
      <div style={{ marginTop: '25px', flexDirection: 'column', display: 'flex', gap: '10px' }}>
        <InputField label={"İsim *"} placeholder={"İsim"} onChange={(e) => setName(e.target.value)} value={name} />
        <InputField label={"Soyisim *"} placeholder={"Soyisim"} onChange={(e) => setLastname(e.target.value)} value={lastname} />
        
        {/* Telefon ile kayıt ise Telefon inputu göster (Disabled), Email gizle */}
        {isPhoneRegistration ? (
            <InputField 
                label={"Telefon No"} 
                value={phoneNumber} 
                disabled={true} 
            />
        ) : (
            /* Email ile kayıt ise Email inputu göster (Disabled) */
            <InputField 
                label={"Email"} 
                placeholder={"Email"} 
                onChange={(e) => setEmail(e.target.value)} 
                value={email} 
                disabled={true}
            />
        )}

        <InputField 
            label={isPhoneRegistration ? "Kimlik No *" : "Kimlik No"} 
            placeholder={"Kimlik No"} 
            maxLength={11} 
            onChange={(e) => setIdentityNo(e.target.value)} 
            value={identityNo} 
        />
      </div>
      
      <Button
        label="Devam et"
        variant="primary"
        disabled={isButtonDisabled}
        style={{ width: '100%', marginTop: '32px', height: '44px' }}
        onClick={createUser}
      />
    </div>
  )
}